"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
exports.Page = ({ children }) => (React.createElement("div", { className: "page-comp" }, children));
exports.Page.displayName = 'Page';



//////////////////
// WEBPACK FOOTER
// ./src/components/Page/Page.tsx
// module id = 362
// module chunks = 0